import React from "react";

import { classnames, Icon } from "@culturehq/components";

interface GrabberIconProps {
  grabberClass: string;
  iconClass: string;
  isVideo: boolean;
}

const GrabberIcon: React.FC<GrabberIconProps> = ({
  grabberClass,
  iconClass,
  isVideo
}) => (
  <Icon
    className={classnames(
      iconClass,
      "Grabber",
      grabberClass,
      { "Grabber-Video": isVideo },
      { [`${grabberClass}__Video`]: isVideo }
    )}
    icon="playback-grabber"
  />
);

export default GrabberIcon;
